import Image from "next/image";

const BASE = "/images/home/technologies";

function createTechIcon(displayName, filename) {
  function TechIcon({ size = 24, width, height, className }) {
    return (
      <Image
        src={`${BASE}/${filename}`}
        alt={displayName}
        width={width ?? size}
        height={height ?? size}
        className={className}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
    );
  }
  TechIcon.displayName = displayName + "Icon";
  return TechIcon;
}

export const ReactIcon = createTechIcon("React", "React.svg");
export const NextjsIcon = createTechIcon("Nextjs", "Next.svg");
export const VueIcon = createTechIcon("Vue", "Vue.svg");
export const AngularIcon = createTechIcon("Angular", "Angular.svg");
export const TypeScriptIcon = createTechIcon("TypeScript", "TypeScript.svg");
export const WordpressIcon = createTechIcon("WordPress", "Wordpress.svg");
export const WooCommerceIcon = createTechIcon("WooCommerce", "WooCommerce.svg");
export const MagnetoIcon = createTechIcon("Magneto", "Magneto.svg");
export const NodejsIcon = createTechIcon("Nodejs", "Node.svg");
export const PythonIcon = createTechIcon("Python", "Python.svg");
export const PhpIcon = createTechIcon("PHP", "PHP.svg");
export const LaravelIcon = createTechIcon("Laravel", "Laravel.svg");
export const DotNetIcon = createTechIcon("DotNet", "NET.svg");
export const AWSIcon = createTechIcon("AWS", "AWS.svg");
export const AzureIcon = createTechIcon("Azure", "Azure.svg");
export const AzureDevopsIcon = createTechIcon(
  "Azure DevOps",
  "Azure-Devops.svg",
);
export const GoogleCloudIcon = createTechIcon(
  "GoogleCloud",
  "Google-Cloud.svg",
);
export const KotlinIcon = createTechIcon("Kotlin", "Kotlin.svg");
export const DockerIcon = createTechIcon("Docker", "Docker.svg");
export const MySqlIcon = createTechIcon("MySQL", "MySQL.svg");
export const PostgreSqlIcon = createTechIcon("PostgreSQL", "PostgresSQL.svg");
export const MongoDbIcon = createTechIcon("MongoDB", "MongoDB.svg");
export const FlutterIcon = createTechIcon("Flutter", "Flutter.svg");
export const SwiftIcon = createTechIcon("Swift", "Swift.svg");
export const NginxIcon = createTechIcon("NGiNX", "NGINX.svg");
export const FigmaIcon = createTechIcon("Figma", "Figma.svg");
export const JenkinsIcon = createTechIcon("Jenkins", "Jenkins.svg");
export const AdobeIcon = createTechIcon("Adobe", "Adobe.svg");
export const AtlassianIcon = createTechIcon("Atlassian", "Atlassian.svg");
export const JavaIcon = createTechIcon("Java", "Java.svg");
export const HTMLIcon = createTechIcon("HTML", "HTML.svg");
export const CodeIgniterIcon = createTechIcon("CodeIgniter", "CodeIgniter.svg");
export const ShopifyIcon = createTechIcon("Shopify", "Shopify.svg");
export const BigCommerceIcon = createTechIcon("BigCommerce", "BigCommerce.svg");
export const AlgoliaIcon = createTechIcon("Algolia", "Algolia.svg");
export const OpenCartIcon = createTechIcon("OpenCart", "OpenCart.svg");
export const DrupalIcon = createTechIcon("Drupal", "Drupal.svg");
export const FirebaseIcon = createTechIcon("Firebase", "Firebase.svg");
export const UIPathIcon = createTechIcon("UI Path", "UI-Path.webp");
export const PowerBIIcon = createTechIcon("Power BI", "Power-BI.svg");
export const PowerAutomateIcon = createTechIcon(
  "Power-Automate",
  "Power-Automate.svg",
);
export const GitIcon = createTechIcon("GIT", "Git.svg");
export const JoomlaIcon = createTechIcon("Joomla", "Joomla.svg");
export const ZohoIcon = createTechIcon("Zoho", "Zoho.svg");
export const NotionIcon = createTechIcon("Notion", "Notion.svg");
export const SeleniumIcon = createTechIcon("Selenium", "Selenium.svg");
export const CypressIcon = createTechIcon("Cypress", "Cypress.svg");
export const MSOfficeIcon = createTechIcon("Microsoft Office", "MS-Office.svg");
export const OpenCVIcon = createTechIcon("OpenCV", "OpenCV.svg");
export const ViteIcon = createTechIcon("Vite", "Vite.svg");
export const ReduxIcon = createTechIcon("Redux", "Redux.svg");
export const MaterialIcon = createTechIcon("Material UI", "Material-UI.svg");
export const SassIcon = createTechIcon("Sass", "Sass.svg");
export const TailwindIcon = createTechIcon("Tailwind CSS", "Tailwind.svg");
export const CSharpIcon = createTechIcon("C#", "C-Sharp.svg");
export const AntDesignIcon = createTechIcon("Ant Design", "Ant-Design.svg");
export const CSSIcon = createTechIcon("CSS", "CSS.svg");
export const JavaScriptIcon = createTechIcon("JavaScript", "JavaScript.svg");
export const FlaskIcon = createTechIcon("Flask", "Flask.svg");
export const TensorFlowIcon = createTechIcon("TensorFlow", "TensorFlow.svg");
export const ApacheIcon = createTechIcon("Apache", "Apache.svg");
export const djangoIcon = createTechIcon("django", "django.svg");
export const RailsIcon = createTechIcon("Rails", "Rails.svg");
export const CpanelIcon = createTechIcon("Cpanel", "Cpanel.svg");
export const jQueryIcon = createTechIcon("jQuery", "jQuery.svg");
export const OracleIcon = createTechIcon("Oracle", "Oracle.svg");
export const QlikIcon = createTechIcon("Qlik", "Qlik.svg");
export const GoLangIcon = createTechIcon("Go Lang", "Go-Lang.svg");
export const FastAPIIcon = createTechIcon("Fast API", "FastAPI.svg");
export const ZimbraIcon = createTechIcon("Zimbra", "Zimbra.webp");
export const PyTorchIcon = createTechIcon("PyTorch", "Pytorch.svg");
export const OpenAIIcon = createTechIcon("OpenAI", "OpenAI.svg");
export const KubernetesIcon = createTechIcon("Kubernetes", "Kubernetes.svg");
export const MLFlowIcon = createTechIcon("ML Flow", "MLFlow.svg");
export const ClaudeIcon = createTechIcon("Claude", "Claude.svg");
export const MulesoftIcon = createTechIcon("Mulesoft", "Mulesoft.svg");
export const GraphqlIcon = createTechIcon("Graphql", "Graphql.svg");
export const Auth0Icon = createTechIcon("Auth0", "Auth0.svg");
export const OktaIcon = createTechIcon("Okta", "Okta.svg");
export const PrometheusIcon = createTechIcon("Prometheus", "Prometheus.svg");
export const PowerShellIcon = createTechIcon("PowerShell", "PowerShell.svg");
export const VeeamIcon = createTechIcon("Veeam", "Veeam.svg");
export const DartIcon = createTechIcon("Dart", "Dart.svg");
export const SpringbootIcon = createTechIcon("Spring Boot", "Springboot.svg");
export const KtorIcon = createTechIcon("Ktor", "Ktor.svg");
export const JestIcon = createTechIcon("Jest", "Jest.svg");
export const GeminiIcon = createTechIcon("Gemini", "Gemini.svg");
export const LlamaIcon = createTechIcon("Llama", "Llama.svg");
export const HuggingFaceIcon = createTechIcon(
  "Hugging Face",
  "HuggingFace.svg",
);
export const LangchainIcon = createTechIcon("Langchain", "Langchain.svg");
export const APIIcon = createTechIcon("API", "API.svg");
export const GutenbergIcon = createTechIcon("Gutenberg", "Gutenberg.svg");
export const ElementorIcon = createTechIcon("Elementor", "Elementor.svg");
export const WPBakeryIcon = createTechIcon("WP Bakery", "WP-Bakery.svg");
export const BootstrapIcon = createTechIcon("Bootstrap", "Bootstrap.svg");
export const DigitalOceanIcon = createTechIcon(
  "Digital Ocean",
  "DigitalOcean.svg",
);
export const BluehostIcon = createTechIcon("Bluehost", "Bluehost.svg");
export const GitHubIcon = createTechIcon("GitHub", "GitHub.svg");
export const BitBucketIcon = createTechIcon("BitBucket", "BitBucket.svg");
export const GitlabIcon = createTechIcon("Gitlab", "Gitlab.svg");
export const WPRocketIcon = createTechIcon("WP-Rocket", "WP-Rocket.svg");
export const RedisIcon = createTechIcon("Redis", "Redis.svg");
export const CloudflareIcon = createTechIcon("Cloudflare", "Cloudflare.svg");
export const WordfenceIcon = createTechIcon("Wordfence", "Wordfence.svg");
export const SucuriIcon = createTechIcon("Sucuri", "Sucuri.svg");
export const SSLIcon = createTechIcon("SSL", "SSL.svg");
export const AndroidIcon = createTechIcon("Android", "Android.svg");
export const AppleIcon = createTechIcon("Apple", "Apple.svg");
export const SQLServerIcon = createTechIcon(
  "Microsoft SQL Server",
  "Microsoft-SQL-Server.svg",
);
export const MS365Icon = createTechIcon("Microsoft 365", "Microsoft_365.webp");
export const SalesforceIcon = createTechIcon("Salesforce", "Salesforce.svg");
export const OdooIcon = createTechIcon("Odoo", "Odoo.svg");
export const SAPIcon = createTechIcon("SAP", "SAP.svg");
export const RestAPIcon = createTechIcon("Rest API", "Rest-api.svg");
export const PaymentGatewayIcon = createTechIcon(
  "Payment Gateway",
  "Payment-Gateway.svg",
);
export const LangGraphIcon = createTechIcon("Lang Graph", "Lang-Graph.svg");
export const CrewaiIcon = createTechIcon("Lang Graph", "Crewai.svg");
export const ScikitLearnIcon = createTechIcon(
  "Scikit Learn",
  "Scikit-learn.svg",
);
export const QdrantIcon = createTechIcon("Qdrant", "Qdrant.svg");
export const PineconeIcon = createTechIcon("Pinecone", "Pinecone.svg");
export const ChromaIcon = createTechIcon("Chroma", "Chroma.svg");
export const OpenclawIcon = createTechIcon("Openclaw", "Openclaw.svg");
export const WhatsappIcon = createTechIcon("Whatsapp", "Whatsapp.svg");
export const SlackIcon = createTechIcon("Slack", "Slack.svg");
export const MSTeamsIcon = createTechIcon(
  "Microsoft Teams",
  "Microsoft-Teams.svg",
);
export const TelegramIcon = createTechIcon("Telegram", "Telegram.svg");
export const FacebookMessengerIcon = createTechIcon(
  "Facebook Messenger",
  "Facebook-Messenger.svg",
);
export const WeaviateIcon = createTechIcon("Weaviate", "Weaviate.svg");
export const MistralIcon = createTechIcon("Mistral", "Mistral.svg");
export const BluePrismIcon = createTechIcon("Blue Prism", "Blue-Prism.svg");
export const GoogleIcon = createTechIcon("Google", "Google.svg");
export const PegaIcon = createTechIcon("Pega", "Pega.svg");
export const WorkFusionIcon = createTechIcon("Work Fusion", "WorkFusion.svg");
export const ABBYYIcon = createTechIcon("ABBYY", "ABBYY.svg");
export const CelonisIcon = createTechIcon("Celonis", "Celonis.svg");
export const PostmanIcon = createTechIcon("Postman", "Postman.svg");
export const AJAXIcon = createTechIcon("AJAX", "AJAX.svg");
export const MariadbIcon = createTechIcon("Mariadb", "Mariadb.svg");
export const GoogleAnalyticsIcon = createTechIcon(
  "Google Analytics",
  "Google-Analytics.svg",
);
export const GoogleTagManagerIcon = createTechIcon(
  "Google Tag Manager",
  "Google-Tag-Manager.svg",
);
export const FacebookIcon = createTechIcon("Facebook", "Facebook.svg");
export const VSCodeIcon = createTechIcon("visual Studio Code", "VS-Code.svg");
export const CocoaPodsIcon = createTechIcon("CocoaPods", "CocoaPods.svg");
export const XcodeIcon = createTechIcon("Xcode", "Xcode.svg");
export const AppcodeIcon = createTechIcon("Appcode", "Appcode.svg");
export const JWTIcon = createTechIcon("JWT", "JWT.svg");
export const StripeIcon = createTechIcon("Stripe", "Stripe.svg");
export const PaypalIcon = createTechIcon("Paypal", "Paypal.svg");
export const RazorpayIcon = createTechIcon("Razorpay", "Razorpay.svg");
export const OpenIDIcon = createTechIcon("OpenID", "OpenID.svg");
export const ExpressIcon = createTechIcon("Express", "Express.svg");
export const NestIcon = createTechIcon("NestJS", "nestJS.svg");
export const TableauIcon = createTechIcon("Tableau", "Tableau.svg");
export const NumpyIcon = createTechIcon("Numpy", "Numpy.svg");
export const HyvaIcon = createTechIcon("Hyva", "Hyva.svg");
export const MongooseIcon = createTechIcon("Mongoose", "Mongoose.svg");
export const RedhatIcon = createTechIcon("Redhat", "Redhat.svg");
export const HelmIcon = createTechIcon("Helm", "Helm.svg");
export const PodmanIcon = createTechIcon("Podman", "Podman.svg");
export const TerraformIcon = createTechIcon("Terraform", "Terraform.svg");
export const AnsibleIcon = createTechIcon("Ansible", "Ansible.svg");
export const PostmanNewmanIcon = createTechIcon(
  "Postman/Newman",
  "PostmanNewman.svg",
);
export const SwaggerOpenAPIIcon = createTechIcon(
  "Swagger/OpenAPI",
  "SwaggerOpenAPI.svg",
);
export const NpmIcon = createTechIcon("npm", "Npm.svg");
export const MoodleIcon = createTechIcon("Moodle", "Moodle.svg");
export const CanvasLMSIcon = createTechIcon("Canvas LMS", "CanvasLMS.svg");
export const GrafanaIcon = createTechIcon("Grafana", "Grafana.svg");
export const DellBoomiIcon = createTechIcon("Dell Boomi", "DellBoomi.svg");
export const KongIcon = createTechIcon("Kong", "Kong.svg");
export const RabbitMQIcon = createTechIcon("RabbitMQ", "RabbitMQ.svg");
export const KeycloakIcon = createTechIcon("Keycloak", "Keycloak.svg");
export const SplunkIcon = createTechIcon("Splunk", "Splunk.svg");
export const DatadogIcon = createTechIcon("Datadog", "Datadog.svg");
export const GraylogIcon = createTechIcon("Graylog", "Graylog.svg");
export const NagiosIcon = createTechIcon("Nagios", "Nagios.svg");
export const ZabbixIcon = createTechIcon("Zabbix", "Zabbix.svg");
export const OpenShiftIcon = createTechIcon("OpenShift", "OpenShift.svg");
export const HashiCorpVaultIcon = createTechIcon(
  "HashiCorp Vault",
  "HashiCorpVault.svg",
);
export const AppiumIcon = createTechIcon("Appium", "Appium.svg");
export const SentryIcon = createTechIcon("Sentry", "Sentry.svg");
export const CrossplaneIcon = createTechIcon("Crossplane", "Crossplane.svg");
export const ArgoCDIcon = createTechIcon("Argo CD", "ArgoCD.svg");
export const ElasticsearchIcon = createTechIcon(
  "Elasticsearch",
  "Elasticsearch.svg",
);
export const LokiIcon = createTechIcon("Loki", "Loki.svg");
export const IstioIcon = createTechIcon("Istio", "Istio.svg");
export const TraefikIcon = createTechIcon("Traefik", "Traefik.svg");
export const KubernetesSecretsIcon = createTechIcon(
  "Kubernetes Secrets",
  "KubernetesSecrets.svg",
);
export const KyvernoIcon = createTechIcon("Kyverno", "Kyverno.webp");
export const AmazonEBSEFSIcon = createTechIcon(
  "Amazon EBS / EFS",
  "AmazonEBSEFS.svg",
);

export const MochaIcon = createTechIcon("Mocha", "Mocha.svg");
export const ChaiIcon = createTechIcon("Chai", "Chai.svg");
export const NgRxIcon = createTechIcon("NgRx", "NgRx.svg");
export const JasmineIcon = createTechIcon("Jasmine", "Jasmine.svg");
export const YarnIcon = createTechIcon("Yarn", "Yarn.svg");
export const SquareIcon = createTechIcon("Square", "Square.svg");
export const BraintreeIcon = createTechIcon("Braintree", "Braintree.svg");
export const TwilioIcon = createTechIcon("Twilio", "Twilio.svg");
export const InformaticaIcon = createTechIcon("Informatica", "Informatica.svg");
export const TalendIcon = createTechIcon("Talend", "Talend.svg");
export const DynatraceIcon = createTechIcon("Dynatrace", "Dynatrace.svg");
export const NewRelicIcon = createTechIcon("New Relic", "NewRelic.svg");
export const PuppetIcon = createTechIcon("Puppet", "Puppet.svg");
export const MobXIcon = createTechIcon("MobX", "MobX.svg");
export const GetXIcon = createTechIcon("GetX", "GetX.svg");
export const MixpanelIcon = createTechIcon("Mixpanel", "Mixpanel.svg");
export const PulumiIcon = createTechIcon("Pulumi", "Pulumi.svg");
export const FluentdIcon = createTechIcon("Fluentd", "Fluentd.svg");
export const LinkerdIcon = createTechIcon("Linkerd", "Linkerd.svg");
export const FalcoIcon = createTechIcon("Falco", "Falco.svg");

export const SocketIOIcon = createTechIcon("Socket.IO", "SocketIO.svg");

export const JMeterIcon = createTechIcon("JMeter", "JMeter.svg");
export const PassportJsIcon = createTechIcon("Passport.js", "PassportJs.svg");
export const BashIcon = createTechIcon("Bash", "Bash.svg");
export const SQLiteIcon = createTechIcon("SQLite", "SQLite.svg");
export const PyTestIcon = createTechIcon("PyTest", "PyTest.svg");
export const BlazorIcon = createTechIcon("Blazor", "Blazor.svg");
export const ASPNETCoreIcon = createTechIcon("ASP.NET Core", "ASPNETCore.svg");
export const NetSuiteIcon = createTechIcon("NetSuite", "NetSuite.svg");
export const WebhooksIcon = createTechIcon("Webhooks", "Webhooks.svg");
export const JSONIcon = createTechIcon("JSON", "JSON.svg");
export const HubSpotIcon = createTechIcon("HubSpot", "HubSpot.svg");
export const XMLIcon = createTechIcon("XML", "XML.svg");
export const PlaywriteIcon = createTechIcon("Playwrite", "Playwrite.svg");
export const VisualStudioIcon = createTechIcon(
  "Visual Studio",
  "Visual-Studio.svg",
);
export const SketchIcon = createTechIcon("Sketch", "Sketch.svg");
export const PhotoshopIcon = createTechIcon("Photoshop", "Photoshop.svg");
export const IllustratorIcon = createTechIcon("Illustrator", "Illustrator.svg");
export const GooglePageSpeedInsightsIcon = createTechIcon(
  "Google PageSpeed Insights",
  "Pagespeedinsights.svg",
);
export const LighthouseIcon = createTechIcon("Lighthouse", "Lighthouse.svg");
export const GoogleSearchConsoleIcon = createTechIcon(
  "Google Search Console",
  "Googlesearchconsole.svg",
);
export const AdobeXDIcon = createTechIcon("Adobe XD", "AdobeXD.svg");
export const InVisionIcon = createTechIcon("InVision", "InVision.svg");
export const BalsamiqIcon = createTechIcon("Balsamiq", "Balsamiq.png");
export const AxureRPIcon = createTechIcon("Axure RP", "AxureRP.png");
export const StorybookIcon = createTechIcon("Storybook", "Storybook.svg");
export const ZeroheightIcon = createTechIcon("Zeroheight", "Zeroheight.svg");
export const MazeIcon = createTechIcon("Maze", "Maze.svg");
export const UserTestingIcon = createTechIcon("UserTesting", "UserTesting.png");
export const HotjarIcon = createTechIcon("Hotjar", "Hotjar.svg");
export const MicrosoftClarityIcon = createTechIcon(
  "Microsoft Clarity",
  "MicrosoftClarity.svg",
);
export const ZeplinIcon = createTechIcon("Zeplin", "Zeplin.svg");
export const AdobeCreativeCloudIcon = createTechIcon(
  "Adobe Creative Cloud",
  "AdobeCreativeCloud.svg",
);
export const WCAGIcon = createTechIcon("WCAG", "WCAG.svg");
export const WAVEIcon = createTechIcon("WAVE", "WAVE.png");
export const AxeDevToolsIcon = createTechIcon(
  "axe DevTools",
  "AxeDevTools.svg",
);
export const MiroIcon = createTechIcon("Miro", "Miro.svg");
export const FigJamIcon = createTechIcon("FigJam", "FigJam.svg");
export const WhimsicalIcon = createTechIcon("Whimsical", "Whimsical.svg");
export const ProtoPieIcon = createTechIcon("ProtoPie", "ProtoPie.svg");
export const OptimalWorkshopIcon = createTechIcon(
  "Optimal Workshop",
  "OptimalWorkshop.svg",
);
export const DovetailIcon = createTechIcon("Dovetail", "Dovetail.svg");
export const WebpackIcon = createTechIcon("Webpack", "Webpack.svg");
export const GTmetrixIcon = createTechIcon("GTmetrix", "GTmetrix.svg");
export const BrowserStackIcon = createTechIcon(
  "BrowserStack",
  "BrowserStack.svg",
);
export const PostCSSIcon = createTechIcon("PostCSS", "PostCSS.svg");
export const ChromeDevToolsIcon = createTechIcon(
  "Chrome DevTools",
  "ChromeDevTools.svg",
);
export const SauceLabsIcon = createTechIcon("Sauce Labs", "SauceLabs.svg");
export const FoundationIcon = createTechIcon("Foundation", "Foundation.svg");
export const LessIcon = createTechIcon("Less", "Less.svg");
export const WebPageTestIcon = createTechIcon("WebPageTest", "WebPageTest.svg");
export const ResponsivelyAppIcon = createTechIcon(
  "Responsively App",
  "ResponsivelyApp.svg",
);
export const WebflowIcon = createTechIcon("Webflow", "Webflow.svg");
export const KlarnaIcon = createTechIcon("Klarna", "Klarna.svg");
export const AuthorizeNetIcon = createTechIcon(
  "Authorize.Net",
  "AuthorizeNet.svg",
);
export const TestRailIcon = createTechIcon("TestRail", "TestRail.svg");
export const ZephyrIcon = createTechIcon("Zephyr", "Zephyr.svg");
export const JiraIcon = createTechIcon("Jira", "Jira.svg");
export const AzureTestPlansIcon = createTechIcon(
  "Azure Test Plans",
  "AzureTest.svg",
);
export const ApacheJMeterIcon = createTechIcon(
  "Apache JMeter",
  "ApacheJMeter.svg",
);
export const LoadRunnerIcon = createTechIcon("LoadRunner", "LoadRunner.svg");
export const GatlingIcon = createTechIcon("Gatling", "Gatling.svg");
export const K6Icon = createTechIcon("k6", "K6.svg");
export const OWASPZAPIcon = createTechIcon("OWASP ZAP", "OWASPZAP.svg");
export const BurpSuiteIcon = createTechIcon("Burp Suite", "BurpSuite.svg");
export const NessusIcon = createTechIcon("Nessus", "Nessus.svg");
export const SnykIcon = createTechIcon("Snyk", "Snyk.svg");
export const EspressoIcon = createTechIcon("Espresso", "Espresso.svg");
export const XCUITestIcon = createTechIcon("XCUITest", "XCUITest.svg");
export const LambdaTestIcon = createTechIcon("LambdaTest", "LambdaTest.svg");
export const RESTAssuredIcon = createTechIcon(
  "REST Assured",
  "REST Assured.svg",
);
export const SoapUIIcon = createTechIcon("SoapUI", "SoapUI.svg");
export const KarateIcon = createTechIcon("Karate", "Karate.svg");
export const SQLIcon = createTechIcon("SQL", "SQL.svg");
export const DBeaverIcon = createTechIcon("DBeaver", "DBeaver.svg");
export const ApplitoolsIcon = createTechIcon("Applitools", "Applitools.svg");
export const TestimIcon = createTechIcon("Testim", "Testim.svg");
export const MablIcon = createTechIcon("Mabl", "Mabl.svg");
export const FunctionizeIcon = createTechIcon("Functionize", "Functionize.svg");
export const LlamaIndexIcon = createTechIcon("LlamaIndex", "LlamaIndex.svg");
export const SemanticKernelIcon = createTechIcon(
  "Semantic Kernel",
  "SemanticKernel.svg",
);
export const RAGIcon = createTechIcon("RAG", "RAG.svg");
export const MilvusIcon = createTechIcon("Milvus", "Milvus.svg");
export const FAISSIcon = createTechIcon("FAISS", "FAISS.svg");
export const N8nIcon = createTechIcon("n8n", "n8n.svg");
export const ZapierIcon = createTechIcon("Zapier", "Zapier.svg");
export const MakeIcon = createTechIcon("Make", "Make.svg");
export const ApacheAirflowIcon = createTechIcon(
  "Apache Airflow",
  "ApacheAirflow.svg",
);
export const ApacheSparkIcon = createTechIcon(
  "Apache Spark",
  "ApacheSpark.svg",
);
export const PandasIcon = createTechIcon("Pandas", "Pandas.svg");
export const SnowflakeIcon = createTechIcon("Snowflake", "Snowflake.svg");
export const KubeflowIcon = createTechIcon("Kubeflow", "Kubeflow.svg");
export const WPCLIIcon = createTechIcon("WP-CLI", "WPCLI.svg");
export const MFAIcon = createTechIcon("Multi-factor Authentication", "MFA.svg");
export const BiometricIcon = createTechIcon(
  "Biometric Authentication",
  "Biometric.svg",
);
export const BlockchainIcon = createTechIcon("Blockchain", "Blockchain.svg");
export const ServiceNowGRCIcon = createTechIcon(
  "ServiceNow GRC",
  "ServiceNowGRC.svg",
);
export const RSAArcherIcon = createTechIcon("RSA Archer", "RSAArcher.svg");
export const OneTrustIcon = createTechIcon("OneTrust", "OneTrust.svg");
export const QualysIcon = createTechIcon("Qualys", "Qualys.svg");
export const TenableIcon = createTechIcon("Tenable", "Tenable.svg");
export const Rapid7Icon = createTechIcon("Rapid7 InsightVM", "Rapid7.svg");
export const PrismaCloudIcon = createTechIcon(
  "Prisma Cloud",
  "PrismaCloud.svg",
);
export const TrustArcIcon = createTechIcon("TrustArc", "TrustArc.svg");
export const BigIDIcon = createTechIcon("BigID", "BigID.svg");
export const MetricStreamIcon = createTechIcon(
  "MetricStream",
  "MetricStream.svg",
);
export const LogicGateIcon = createTechIcon("LogicGate", "LogicGate.svg");
export const AuditBoardIcon = createTechIcon("AuditBoard", "AuditBoard.svg");
export const AccessibilityInsightsIcon = createTechIcon(
  "Accessibility Insights",
  "AccessibilityInsights.svg",
);
export const ChefInSpecIcon = createTechIcon("Chef InSpec", "ChefInSpec.svg");
export const OpenSCAPIcon = createTechIcon("OpenSCAP", "OpenSCAP.svg");
export const CISCATProIcon = createTechIcon("CIS-CAT Pro", "CISCATPro.svg");
export const DrataIcon = createTechIcon("Drata", "Drata.svg");
export const VantaIcon = createTechIcon("Vanta", "Vanta.svg");
export const SecureframeIcon = createTechIcon("Secureframe", "Secureframe.svg");
export const MCPIcon = createTechIcon("Model Context Protocol", "MCP.svg");
export const A2AIcon = createTechIcon("Agent2Agent Protocol", "A2A.svg");
export const FunctionCallingIcon = createTechIcon(
  "Function Calling",
  "FunctionCalling.svg",
);
export const AutoGenIcon = createTechIcon("AutoGen", "AutoGen.svg");
export const LangSmithIcon = createTechIcon("LangSmith", "LangSmith.svg");
export const LangfuseIcon = createTechIcon("Langfuse", "Langfuse.svg");
export const RIcon = createTechIcon("R", "R.svg");
export const ScalaIcon = createTechIcon("Scala", "Scala.svg");
export const JuliaIcon = createTechIcon("Julia", "Julia.svg");
export const KerasIcon = createTechIcon("Keras", "Keras.svg");
export const SciPyIcon = createTechIcon("SciPy", "SciPy.svg");
export const RayIcon = createTechIcon("Ray", "Ray.svg");
export const MediaPipeIcon = createTechIcon("MediaPipe", "MediaPipe.svg");
export const SpaCyIcon = createTechIcon("spaCy", "spaCy.svg");
export const RoboflowIcon = createTechIcon("Roboflow", "Roboflow.svg");
export const ApacheKafkaIcon = createTechIcon(
  "Apache Kafka",
  "ApacheKafka.svg",
);
export const DbtIcon = createTechIcon("dbt", "dbt.svg");
export const BigQueryIcon = createTechIcon("Google BigQuery", "BigQuery.svg");
export const ONNXIcon = createTechIcon("ONNX", "ONNX.svg");
export const DatabricksIcon = createTechIcon("Databricks", "Databricks.svg");
export const NVIDIAIcon = createTechIcon("NVIDIA", "NVIDIA.svg");
export const WeightsBiasesIcon = createTechIcon(
  "Weights & Biases",
  "WeightsBiases.svg",
);
export const PlotlyIcon = createTechIcon("Plotly", "Plotly.svg");
export const MatplotlibIcon = createTechIcon("Matplotlib", "Matplotlib.svg");
export const OAuthIcon = createTechIcon("OAuth", "OAuth.svg");
export const DataEncryptionIcon = createTechIcon(
  "Data Encryption",
  "DataEncryption.svg",
);
export const RBACIcon = createTechIcon("Role-Based Access Control", "RBAC.svg");
export const GDPRIcon = createTechIcon("GDPR", "GDPR.svg");
export const LookerIcon = createTechIcon("Looker", "Looker.svg");
export const RedshiftIcon = createTechIcon("Redshift", "Redshift.svg");
export const FivetranIcon = createTechIcon("Fivetran", "Fivetran.svg");
export const HadoopIcon = createTechIcon("Hadoop", "Hadoop.svg");
export const KafkaIcon = createTechIcon("Kafka", "Kafka.svg");
export const DAXIcon = createTechIcon("DAX", "DAX.svg");

export const AcunetixIcon = createTechIcon("Acunetix", "Acunetix.svg");
export const OpenVASIcon = createTechIcon("OpenVAS", "OpenVAS.svg");
export const MetasploitIcon = createTechIcon("Metasploit", "Metasploit.svg");
export const SQLmapIcon = createTechIcon("SQLmap", "SQLmap.svg");
export const HydraIcon = createTechIcon("Hydra", "Hydra.svg");
export const NmapIcon = createTechIcon("Nmap", "Nmap.svg");
export const WiresharkIcon = createTechIcon("Wireshark", "Wireshark.svg");
export const OWASPIcon = createTechIcon("OWASP", "OWASP.svg");
export const NISTIcon = createTechIcon("NIST", "NIST.svg");
export const MITREATTACKIcon = createTechIcon("MITRE ATT&CK", "MITREATTACK.svg");
